import type { GqlClient } from '@/types/gqlClient'
import { graphql } from 'gql.tada'
import { FileUploadConfiguration } from '../types'

/**
 * GraphQL query for getFileUploadConfiguration action
 */
const GET_FILE_UPLOAD_CONFIGURATION_QUERY = graphql(`
  query GetFileUploadConfiguration {
    getFileUploadConfiguration {
      allowedMimeTypes
      usageSizeLimits
      pathConstraints {
        allowedPrefixes
        maxPathLength
        filenamePattern
        maxFilenameLength
      }
      uploadConstraints {
        presignedUrlExpirySeconds
        jwtExpirySeconds
        maxPendingUploadsPerUser
        maxUploadsPerProjectPerHour
      }
      usageTypes
      sections
    }
  }
`)

/**
 * Service function to fetch file upload configuration
 */
export const getFileUploadConfiguration = (gqlClient: GqlClient): Promise<FileUploadConfiguration> => {
  return gqlClient
    .request(GET_FILE_UPLOAD_CONFIGURATION_QUERY)
    .then((data) => {
      return data.getFileUploadConfiguration as FileUploadConfiguration
    })
}
